/** @format */

function isNullOrEmpty(str) {
  return str == null || str === '' || str == undefined
}
function ellipsize(str, maxLength) {
  if (str.length > maxLength) {
    return str.substr(0, maxLength) + '...'
  }
  return str
}

function getShortName(name) {
  return ellipsize(name, 5)
}

function stringFormat(formatStr, args = []) {
  let resultStr = formatStr
  if (args.length > 0) {
    for (let idx = 0; idx < args.length; idx++) {
      let rp = /%(\d+\$)?([-#+ 0,(<]*)?(\d+)?(\.\d+)?([tT])?([a-zA-Z%])/.exec(resultStr)
      if (rp == null) {
        resultStr += args[idx]
        resultStr += ' '
      } else {
        if (args[idx] === undefined) {
          resultStr = resultStr.replace(rp[0], '*')
        } else {
          resultStr = resultStr.replace(rp[0], args[idx])
        }
      }
    }
  }
  return resultStr
}

const TextUtil = {
  isNullOrEmpty,
  ellipsize,
  getShortName,
  stringFormat,
}
export { TextUtil as default }
